export const SIDEBAR_WIDTH_FULL = 260;
export const SIDEBAR_WIDTH_REDUCED = 64;
